import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Time} from '@shared/time-picker/time';
import {format} from 'date-fns';

export function getKeyFromValue(enumObject: any, value: string | number): string | undefined
{
    let enumKey;

    for (const key in enumObject)
    {
        if (enumObject[key] === value)
        {
            enumKey = key;
        }
    }

    return enumKey;
}

export function getFormattedTime(time: Time): string
{
    if (!time)
    {
        return;
    }
    
    const hour = `${time.hour < 10 ? '0' : ''}${time.hour}`;
    const minute = `${time.minute < 10 ? '0' : ''}${time.minute}`;
    const second = `${time.second < 10 ? '0' : ''}${time.second}`;

    return `${hour}:${minute}:${second}`;
}

export function getFormattedDate(date: NgbDate): string
{
    if (!date)
    {
        return '';
    }

    const jsDate = new Date(date.year, date.month - 1, date.day);

    return format(jsDate, 'yyyy-MM-dd');
}

export function removeNullProperties<T>(obj: Record<string, any>): T
{
    return Object.entries(obj)
        .filter(([, value]) => value !== null && value !== undefined)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}) as T;
}

export function formatDateToObject(date: string | Date): NgbDate
{
    const newDate = new Date(date);

    return new NgbDate(newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate());
}

export function formatTimeToObject(date: string | Date): Time
{
    const newDate = new Date(date);

    return new Time(newDate.getHours(), newDate.getMinutes(), newDate.getSeconds());
}

export function generateUID(length = 6): string
{
    return Array.from(crypto.getRandomValues(new Uint8Array(length)))
        .map((byte) => byte.toString(36).padStart(2, '0'))
        .join('')
        .slice(0, length);
}

export function getNormalizedValue(value: string): string
{
    return value?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '')?.toLowerCase();
}
